import { render, staticRenderFns } from "./DeliveryModel.vue?vue&type=template&id=43f4744c"
import script from "./DeliveryModel.vue?vue&type=script&lang=js"
export * from "./DeliveryModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports